const $ = window.jQuery;

if ( $( '.iec-campus-tour-form' ).length ) {

	$( '.iec-campus-tour-form' ).find( 'select[name="input_10"]' ).change( function() {
		onDateChange();
	} );

	onDateChange();

	function onDateChange() {

		const isToday = $( '.iec-campus-tour-form' ).find( 'select[name="input_10"] option:selected' ).val() === $( '.iec-campus-tour-form' ).find( 'select[name="input_10"] option' ).eq(1).val();

		$( '.iec-campus-tour-form' ).find( 'select[name="input_11"] option' ).removeAttr( 'disabled' );

		if ( isToday ) {

			// Only allow time slots one hour or more in the future.
			$( '.iec-campus-tour-form' ).find( 'select[name="input_11"] option' ).each( function() {

				const time = $( this ).val();
				if ( '' === time ) {
					return;
				}

				const now = Date.now();
				if ( now + ( 60 * 60 * 1000 ) > $( this ).data( 'today-timestamp' ) ) {
					$( this ).attr( 'disabled', 'disabled' );
				}
			} );

		}

		$( '.iec-campus-tour-form' ).find( 'select[name="input_11"]' ).trigger( 'chosen:updated' );

	}

}
